import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import * as translator from '../../../../utils/translator';
import { MainTracker } from '../../../../PixelTrackers/MainTracker';
import CarePlusWordmark from '../CarePlusOrderDetail/CarePlusWordmark';
import SubscriptionSuggestionCard from './SubscriptionSuggestionCard';
import { getQuestionnaireMention } from '../../../../utils/funnelMentionRedirects';
import heroPhoto from '../../../../images/CarePlus/weight-loss-upsell-hero.png';

const CarePlusWeightLossUpsellCard: React.FC = () => {
  const { country, language } = useOutletContext<any>();
  const t = (path: string) => translator.translate(language, 'my_account', path);
  // The UK links weight_loss, so the UK WL1 vs WL2 split (uk_wl2_split_weight) decides the funnel.
  const wlMention = country?.toLowerCase() === 'gb' ? 'weight_loss' : getQuestionnaireMention(country, 'weight_loss_2');

  const benefits = [
    t('CarePlus/upsell/benefit1'),
    t('CarePlus/upsell/benefit2'),
    t('CarePlus/upsell/benefit3'),
    t('CarePlus/upsell/benefit4'),
    t('CarePlus/upsell/benefit5'),
  ];

  return (
    <SubscriptionSuggestionCard
      theme="careplus"
      image={heroPhoto}
      title={
        <>
          {t('CarePlus/upsell/titlePrefix')}
          <span className="subscription-suggestion-card__title-mark"><CarePlusWordmark fontSize={24} topOffset={1} /></span>
          {t('CarePlus/upsell/titleSuffix')}
        </>
      }
      includesTitle={t('CarePlus/landing/planIncludes')}
      benefits={benefits}
      categoriesSection={
        <div>
          <h3 className="subscription-suggestion-card__section-heading">{t('myAccountSubscription/categories_heading')}</h3>
          <Link
            to={`/questionnaire/${country}/${language}/${wlMention}`}
            onClick={() => MainTracker.track('custom', 'Start consultation from Care+ upsell card', { 'Chosen category': country?.toLowerCase() === 'gb' ? 'weight_loss' : 'weight_loss_2' })}
            className="subscription-suggestion-card__categories-link"
          >
            {t('CarePlus/upsell/categoryLabel')}
          </Link>
        </div>
      }
      paymentHeading={t('myAccountSubscription/payment_heading')}
      showKlarna={country === 'de'}
      cta={{
        label: t('myAccountSubscription/show_categories_button'),
        to: `/questionnaire/${country}/${language}/${wlMention}`,
        onClick: () => MainTracker.track('custom', 'Start consultation from Care+ upsell card', { 'Chosen category': country?.toLowerCase() === 'gb' ? 'weight_loss' : 'weight_loss_2' }),
      }}
    />
  );
};

export default CarePlusWeightLossUpsellCard;
